import { luscinia } from "./luscinia";

luscinia.initMultiSelect2 = async function (filter) {
    const modulePath = $(filter).data("luscinia-modulepath");
    const modulePathsToRender = ["/data/keytypes", "/data/cylinders"];

    if (!modulePath || !modulePathsToRender.includes(modulePath)) return;

    const keyCertificateInputEl = $("input[name='KeyCertificateId']");
    const recordId: string = filter.data("luscinia-record-id");

    const container = document.createElement("div");
    filter.append(container);
    await renderMultiSelectFormGroup(container, modulePath, recordId, keyCertificateInputEl.val().toString());

    $(keyCertificateInputEl).on("change", async () => {
        await renderMultiSelectFormGroup(container, modulePath, recordId, keyCertificateInputEl.val().toString());
    });
};

async function renderMultiSelectFormGroup(container: HTMLElement, modulePath: string, recordId: string, keyCertificateId: string) {
    container.innerHTML = "";

    let label = "",
        dataUrl = "",
        selectedOptions: string[] = [];

    switch (modulePath) {
        case "/data/keytypes":
            label = "Cylinders";
            dataUrl = `/data/cylinders/select2/key-certificate/${keyCertificateId}`;
            selectedOptions = await (await fetch(`/data/keytypes/cylinders/${recordId}`)).json();
            break;
        case "/data/cylinders":
            label = "KeyTypes";
            dataUrl = `/data/keytypes/select2/key-certificate/${keyCertificateId}`;
            selectedOptions = await (await fetch(`/data/cylinders/keytypes/${recordId}`)).json();
            break;
        default:
            return;
    }

    try {
        const options: Select2Option[] = await (await fetch(dataUrl)).json();
        container.innerHTML = `
            <div class="grid mb-2">
                <label class="g-col-2 control-label">${label}</label>
                <div class="g-col-10 property-container">
                    ${renderMultiSelect2(label, options, selectedOptions).outerHTML}
                </div>
            </div>
        `;

        $(container).find(".select2-multi-select").select2({ theme: 'bootstrap-5' });
    } catch (error) {
        console.error("Error fetching or rendering MultiSelect2:", error);
    }
}

type Select2Option = {
    id: string;
    text: string;
};

function renderMultiSelect2(name: string, options: Select2Option[], selectedOptions: string[]) {
    const select = document.createElement("select");
    select.setAttribute("multiple", "multiple");
    select.setAttribute("name", name);
    select.classList.add("select2-multi-select");

    options.forEach((option) => {
        let optionEl = document.createElement("option");
        optionEl.text = option.text;
        optionEl.value = option.id;
        if (selectedOptions.includes(option.id)) optionEl.setAttribute("selected", "selected");

        select.options.add(optionEl);
    });

    return select;
}
